// extracted by mini-css-extract-plugin
module.exports = {"bp-tablet-small-viewport":"(min-width: 768px)","bp-desktop-medium-viewport":"(min-width: 1280px)","single-column":"content-layout-grid_single-column__ixuyT"};